import alphaApp from "../assets/images/Alpha Health App.png";
import farmz2u from "../assets/images/Farmz2U.png";
function Work() {
  return (
    <>
      <section class="l-contain l-section l-section--separated" id="product">
        <h2 class="u-small-title">Places and Project I Have Worked At/On</h2>

        <div>
          <ul class="u-simple-list | home-product-list projects">
            <li class="c-limit-width | product-role__list-item">
              <figure>
                <img src={alphaApp} alt="alphaApp Logo" />
                <figcaption>Alpha Health App</figcaption>
              </figure>
            </li>
            <li class="c-limit-width | product-role__list-item">
              <figure>
                <img src={farmz2u} alt="Farmz2U Logo" />
                <figcaption>
                  Farmz2U (Junior DevOps Engineer and Executive Assistant to the
                  CTO)
                </figcaption>
              </figure>
            </li>
          </ul>
        </div>
      </section>
    </>
  );
}

export default Work;
